import { createActions } from 'redux-actions';

const {
    set404,
}: {
    set404?: any;
} = createActions('SET_404');

export { set404 };
